<div>
  <form [formGroup]="formulario">
    <div [ngStyle]="{'padding': paddingFields}">
      <div class="ps-row" fxLayout="row" *ngFor="let field of fields; let i = index">
        <div fxFlex *ngIf="field.formControlName">
          <mat-form-field appearance="fill" fxFlex class="field-infix-width-auto">
            <mat-label>{{field.label}}</mat-label>
            <input *ngIf="field.type == 'text'" [formControlName]="field.formControlName" matInput type="text">
            <input *ngIf="field.type == 'number'" [formControlName]="field.formControlName" matInput type="number">
            <input *ngIf="field.type == 'date'" mask="00/00/0000" [formControlName]="field.formControlName" matInput
              type="text">
            <input *ngIf="field.type == 'cpf'" mask="000.000.000-00" [formControlName]="field.formControlName" matInput
              type="text">
            <mat-error *ngIf="formulario.get(field.formControlName)?.hasError('required')">
              Campo inválido
            </mat-error>
            <mat-error *ngIf="formulario.get(field.formControlName)?.hasError('invalidCPF')">
              CPF inválido
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      @if(recaptcha && recaptcha.active && recaptcha.captcha_portal_active) {
        <div>
          <app-recaptcha-render [dialogRef]="dialogRef" [form]="formulario" [recaptcha]="recaptcha" [isDialog]="isDialog"
            (sendTokenEvent)="sendedToken($event)" (sendError)="captureErrorCaptcha($event)"
            (expiredToken)="expiredToken()">
          </app-recaptcha-render>
        </div>
      }
      @if(!isDialog) {
        <div fxLayout="row" class="content-singup-link">
          <div fxFlex fxLayoutAlign="center center">
            <span>Não possui inscrição? <a [routerLink]="['/', domainParam]" class="signup-link">Clique aqui</a> e faça
              agora!</span>
          </div>
        </div>
        <div fxLayout="row">
          <div fxFlex fxLayoutAlign="center center">
            <button fxFlex="70" [disabled]="!formulario.valid  || invalidCaptcha" mat-raised-button (click)="onSubmit()"
              color="primary">
              Acessar
            </button>
          </div>
        </div>
      }
    </div>
  </form>
  @if(isDialog) {
    <div fxLayout="column">
      <div fxLayout="row">
        <div fxFlex>
          <mat-divider></mat-divider>
        </div>
      </div>
      <div fxLayout="row" class="ps-dialog-content-actions" fxLayoutAlign="end end"
        [ngClass]="{'ps-dialog-content-actions-desactive-captcha': this.errorCaptcha || (!this.recaptcha || !this.recaptcha.active)}">
        <div fxFlex fxLayoutAlign="end end">
          <a (click)="dialogRef.close()" mat-stroked-button>
            Cancelar
          </a>
          <button [disabled]="!formulario.valid || invalidCaptcha" mat-raised-button (click)="onSubmit()" color="primary">
            Acessar
          </button>
        </div>
      </div>
    </div>
  }
</div>
